import { CoreApi, CoreApiProvider, LandingPageContainer, LandingPageDataDTO, LoadingIndicator, Select, ToggleButtons } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { getUserFileImage } from '@/services/files';
import { getConstructionPhases, getLandingPageData } from '@/services/projects';
import { BygrProjectDetails } from '@/types';
import { useAsyncState } from '@/utils/hooks';
import theme from './LandingPage.module.scss';

interface ProjectLandingPageProps {
    project: BygrProjectDetails;
}
export interface ConstructionPhase {
    id: number;
    projectId: number;
    name: string;
}
const ProjectLandingPage: React.FC<ProjectLandingPageProps> = ({ project }) => {
    const [data] = useAsyncState(() => getLandingPageData(project.id), [project.id], null);
    const [constructionPhases] = useAsyncState(() => getConstructionPhases(project.id), [project.id], null);
    const [activeConstructionPhase, setActiveConstructionPhase] = useState<number | null>(null);
    const [activeModule, setActiveModule] = useState('cm');

    if (data === null) {
        return <LoadingIndicator />;
    }

    if (!constructionPhases) return <LoadingIndicator />;
    const options = [{ value: null, label: `Default` }, ...constructionPhases.map((x) => ({ value: x.id, label: x.name }))];

    const landingPageData: LandingPageDataDTO = {
        images:
            activeModule === 'cm'
                ? data.cmImages
                      .filter((x) => x.userFileId && x.constructionPhaseId === activeConstructionPhase)
                      .map((x) => ({ ...x, id: x.userFileId! }))
                : data.amImages
                      .filter((x) => x.userFileId && x.constructionPhaseId === activeConstructionPhase)
                      .map((x) => ({ ...x, id: x.userFileId! })),
        contacts: [],
        details: [],
        floorPlans: [],
        messages: [],
        milestones: [],
        projectId: project.id,
        settings: [],
        showBackgroundImage: false,
    };

    const apiHack = new CoreApi();
    apiHack.landingPage.getImageUrl = (imageId: number) => {
        return getUserFileImage(imageId);
    };

    return (
        <CoreApiProvider projectId={project.id} api={apiHack} profileId={project.sellerProfile.id}>
            <div className={theme.landingPageContainer}>
                <LandingPageContainer data={landingPageData}>
                    <div className={theme.filterContainer}>
                        <Select
                            onChange={(v) => setActiveConstructionPhase((v as { value: number | null }).value ?? null)}
                            placeholder={`Select construction phase`}
                            options={options}
                            value={options.find((x) => x.value === activeConstructionPhase)}
                        />
                        <ToggleButtons>
                            <ToggleButtons.Button onClick={() => setActiveModule('cm')} isActive={activeModule === 'cm'}>
                                CM
                            </ToggleButtons.Button>
                            <ToggleButtons.Button onClick={() => setActiveModule('am')} isActive={activeModule === 'am'}>
                                Am
                            </ToggleButtons.Button>
                        </ToggleButtons>
                    </div>
                </LandingPageContainer>
            </div>
        </CoreApiProvider>
    );
};

export default ProjectLandingPage;
